export default __webpack_public_path__ + "f4bf3b7d76074b13333e724d99aadae9.svg";